var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPatients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.723,
    height: 24.327,
    viewBox: "0 0 27.723 24.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501",
    transform: "translate(-1876.9 -3620.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630",
    transform: "translate(1877.4 3632.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4506",
    "data-name": "Path 4506",
    d: "M1902.667,3674.6h-23.812a1.458,1.458,0,0,0-1.455,1.455V3686.6h3.248a1.368,1.368,0,0,0,1.371-1.371v-2.025a1.846,1.846,0,0,1,1.856-1.856h13.773a1.846,1.846,0,0,1,1.856,1.856v2.025a1.368,1.368,0,0,0,1.371,1.371h3.248v-10.546A1.458,1.458,0,0,0,1902.667,3674.6Z",
    transform: "translate(-1877.4 -3674.6)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637",
    transform: "translate(1878.391 3620.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632",
    transform: "translate(8.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631",
    transform: "translate(1.708)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 2.468,
    cy: 2.932,
    rx: 2.468,
    ry: 2.932,
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    d: "M1923.125,3647.8l-2.025,1.793v3.86",
    transform: "translate(-1921.1 -3642.126)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4508",
    "data-name": "Path 4508",
    d: "M1950.8,3647.8l2.025,1.793v3.86",
    transform: "translate(-1944.536 -3642.126)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633",
    transform: "translate(1.73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    cx: 2.468,
    cy: 2.932,
    rx: 2.468,
    ry: 2.932,
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M1884.125,3647.8l-2.025,1.793v3.86",
    transform: "translate(-1882.1 -3642.126)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1252",
    "data-name": "Line 1252",
    x2: 1.961,
    y2: 1.793,
    transform: "translate(6.264 5.674)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636",
    transform: "translate(16.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635",
    transform: "translate(1.561)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    cx: 2.468,
    cy: 2.932,
    rx: 2.468,
    ry: 2.932,
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4510",
    "data-name": "Path 4510",
    d: "M1989.7,3647.8l2.025,1.793v3.86",
    transform: "translate(-1983.52 -3642.126)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1253",
    "data-name": "Line 1253",
    x1: 1.94,
    y2: 1.793,
    transform: "translate(0 5.674)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4511",
    "data-name": "Path 4511",
    d: "M1907.4,3680.6H1883.59a.189.189,0,0,0-.19.19v1.645h24.192v-1.645A.2.2,0,0,0,1907.4,3680.6Z",
    transform: "translate(-4.735 -47.109)",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPatients);
export default __webpack_public_path__ + "static/media/WaitingPatients.9a402ea3789c67ef88a5e3dd1ae11bcd.svg";
export { ForwardRef as ReactComponent };